// Shared start-up for every page: reveal, smooth scroll, FAQ, nav + wallet, config.
import { initFaq } from "./faq.js";
import { loadConfig } from "./config.js";
import { applyConfigToChrome, initNav } from "./nav.js";
import { initReveal } from "./reveal.js";
import { initSmooth } from "./smooth.js";
import { initImageFallback } from "./ui.js";
import { initWallet } from "./wallet.js";

let booted = null;

/** Resolves with the site config (defaults if /api/config is unreachable; see configError()). */
export function boot() {
  if (booted) return booted;
  window.__noticedReady = true;
  initReveal();
  initSmooth();
  initFaq();
  initImageFallback();
  initNav();
  initWallet();
  booted = loadConfig().then((cfg) => {
    applyConfigToChrome(cfg);
    return cfg;
  });
  return booted;
}
